import { useFavorites } from '@/hooks/useFavorites';

interface FavoriteButtonProps {
  id: string;
  label?: string;
  variant?: 'icon' | 'full';
}

export default function FavoriteButton({ id, label = '收藏', variant = 'icon' }: FavoriteButtonProps) {
  const { isFavorite, toggle } = useFavorites();
  const active = isFavorite(id);

  if (variant === 'full') {
    return (
      <button
        type="button"
        onClick={() => toggle(id)}
        className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border px-3.5 py-2 text-sm font-label transition-colors ${
          active
            ? 'border-accent-300 bg-accent-100 text-accent-800'
            : 'border-background-300 bg-background-50 text-foreground-600 hover:border-accent-300 hover:text-accent-700'
        }`}
      >
        <i className={active ? 'ri-heart-3-fill' : 'ri-heart-3-line'}></i>
        {active ? '已收藏' : label}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => toggle(id)}
      aria-label={active ? '取消收藏' : '收藏'}
      className={`flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-md border transition-colors ${
        active
          ? 'border-accent-300 bg-accent-100 text-accent-700'
          : 'border-background-300 bg-background-50 text-foreground-500 hover:border-accent-300 hover:text-accent-600'
      }`}
    >
      <i className={active ? 'ri-heart-3-fill' : 'ri-heart-3-line'}></i>
    </button>
  );
}